export default {
      id: "close-fill-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "icons-sprite.626747e.svg#close-fill-usage",
      toString: function () {
        return this.url;
      }
    }